import { isPublicTemplateViewMode } from '~/utils/public-template-view-mode-flow.utils';
import { isViewerMode } from '~/utils/viewer-mode-flow.utils';

export const isUserLessMode = () => {
    return isViewerMode() || isPublicTemplateViewMode();
};
